"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ScoutVoiceControlSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4, sm: 5, md: 6 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            backgroundColor: "#F7F4FD",
            borderRadius: { xs: "16px", md: "20px" },
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, md: 5 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1.2fr" },
            gap: { xs: 3, md: 6 },
            alignItems: "center",
          }}
        >
          {/* Left - Label + Heading */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              sx={{
                fontSize: { xs: "10px", sm: "11px" },
                fontWeight: 600,
                color: "#A020E8",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                fontFamily: "var(--font-outfit)",
                mb: { xs: 1.5, sm: 2 },
              }}
            >
              {t("scoutVoiceControl.label")}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "24px", sm: "28px", md: "32px", lg: "34px" },
                fontWeight: 700,
                lineHeight: 1.2,
                color: "#14122B",
                fontFamily: "var(--font-plusjakarta)",
              }}
            >
              {t("scoutVoiceControl.heading")}
            </Typography>
          </Box>

          {/* Right - Paragraph */}
          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "14.5px" },
              color: "#3E3E56",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("scoutVoiceControl.description")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ScoutVoiceControlSection;